import { render, staticRenderFns } from "./ButtonDefault.vue?vue&type=template&id=58121520&scoped=true&"
import script from "./ButtonDefault.vue?vue&type=script&lang=js&"
export * from "./ButtonDefault.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDefault.vue?vue&type=style&index=0&id=58121520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58121520",
  null
  
)

export default component.exports